import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import ScheduleApi from "api/schedule.api";
import {serviceScheduleDestroy, serviceScheduleSave, serviceScheduleUpdateAction} from "services/schedule.service";

const ScheduleContext = createContext();

export const ScheduleProvider = ({children}) => {

    const translateKey = 'crm.Schedule';
    const permission = 'schedule';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(ScheduleApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await serviceScheduleUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await serviceScheduleDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await serviceScheduleSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave
    };

    return <ScheduleContext.Provider value={values}>
        {children}
    </ScheduleContext.Provider>
}

export const useScheduleContext = () => useContext(ScheduleContext);
